export default "__VITE_ASSET__CecKj55J__"